import { PropsWithChildren, useEffect } from 'react';

import { useLocation } from 'react-router-dom';

import { useAuth } from '@/hooks/useAuth';
import { useLangDetection } from '@/hooks/useLangDetection';
import { useRedirectUrl } from '@/hooks/useRedirectUrl';

export const AppWrapper = ({ children }: PropsWithChildren) => {
  const { pathname } = useLocation();

  const { handleLogin } = useAuth();
  useLangDetection();
  useRedirectUrl();

  useEffect(() => {
    handleLogin();
  }, []);

  useEffect(
    () => window.parent.postMessage({ type: 'scrollTop' }, '*'),
    [pathname],
  );

  return <>{children}</>;
};
